import { Gender, LpsDolsSetting, PeopleNominatives } from '@lmc/ts-common'
import {
  type EthnicityCode,
  EthnicityDescriptionEnum,
  GenderIdentityDescriptionEnum,
  GenderIdentityDisplayLabelEnum,
  GenderIdentityEnum,
  type MaritalStatusCode,
  MaritalStatusDescriptionEnum,
  type MentalCapacityToConsent,
  MentalCapacityToConsentSchema,
  type PregnancyStatusCode,
  PregnancyStatusDescriptionEnum,
  type ReligionCode,
  ReligionDescriptionEnum,
  SexDescriptionEnum,
  SexEnum,
  type SexualOrientationCode,
  SexualOrientationDescriptionEnum
} from '@lmc/validations'
import type { BaseOptionType } from 'antd/es/select'
import dayjs from 'dayjs'

// https://cdn2.iconfinder.com/data/icons/business-office-14/256/5-128.png ????
// move prifile pic from marketing to backend!
export const images = {
  learn_more_advert:
    'https://s3.eu-west-2.amazonaws.com/lmc-data-production/public/careoffice-home-screen-advert.png',
  profile_placeholder:
    'https://s3.eu-west-2.amazonaws.com/lmc-data-production/public/profile_pic_placeholder.png',
  list_bullet:
    'https://s3.eu-west-2.amazonaws.com/lmc-data-production/public/list-style.png',
  list_bullet_last:
    'https://s3.eu-west-2.amazonaws.com/lmc-data-production/public/list-style-last.png',
  green_tick:
    'https://s3.eu-west-2.amazonaws.com/lmc-data-production/public/green-tick.png',
  icon_arrow_right:
    'https://s3.eu-west-2.amazonaws.com/lmc-data-production/icons/right-arrow.png',
  // icon_arrow_top: 'https://s3.eu-west-2.amazonaws.com/lmc-data-production/icons/left-arrow.png',
  icon_arrow_left:
    'https://s3.eu-west-2.amazonaws.com/lmc-data-production/icons/left-arrow.png',
  icon_arrow_down:
    'https://s3.eu-west-2.amazonaws.com/lmc-data-production/icons/down-arrow.png',
  icon_bed:
    'https://s3.eu-west-2.amazonaws.com/lmc-data-production/icons/bed_icon.png',
  icon_chair:
    'https://s3.eu-west-2.amazonaws.com/lmc-data-production/icons/chair_icon.png',
  icon_standing:
    'https://s3.eu-west-2.amazonaws.com/lmc-data-production/icons/standing_icon.png'
}

export const ICON_PATHS = {
  calendar:
    'M8 3H6V5H8V3ZM18 3H16V5H18V3ZM5 19H19V10H5V19ZM5 5.001C3.901 5.001 3 5.9 3 6.999V19C3 20.1 3.901 21 5 21H19C20.1 21 21 20.1 21 19V6.999C21 5.9 20.1 5.001 19 5.001H5Z',
  'care-plans':
    'M14.2857 8.08333C14.2857 7.53105 13.838 7.08333 13.2857 7.08333H6.71428C6.162 7.08333 5.71429 7.53105 5.71429 8.08333V17H18.5714C19.3571 17 20 16.3625 20 15.5833V8.5H14.2857V8.08333ZM12.8571 9.20833C12.8571 9.59953 12.54 9.91667 12.1488 9.91667H7.85119C7.45999 9.91667 7.14286 9.59953 7.14286 9.20833C7.14286 8.81713 7.45999 8.5 7.85119 8.5H12.1488C12.54 8.5 12.8571 8.81713 12.8571 9.20833ZM18.5714 2.83333H10V1.41667C10 0.481667 9.55714 0 8.57143 0H1.42857C0.642857 0 0 0.6375 0 1.41667V15.5833C0 16.3625 0.642857 17 1.42857 17H4.28571V7.08333C4.28571 6.30417 4.92857 5.66667 5.71429 5.66667H14.2857C15.0714 5.66667 15.7143 6.30417 15.7143 7.08333H20V4.25C20 3.47083 19.3571 2.83333 18.5714 2.83333ZM8.57143 2.125C8.57143 2.5162 8.2543 2.83333 7.86309 2.83333H2.13691C1.7457 2.83333 1.42857 2.5162 1.42857 2.125C1.42857 1.7338 1.7457 1.41667 2.1369 1.41667H7.86309C8.2543 1.41667 8.57143 1.7338 8.57143 2.125Z',
  grid: 'M4 8H8V4H4V8ZM10 20H14V16H10V20ZM4 20H8V16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H16V20Z',
  'health-visit':
    'M10 2C8.35547 2 7 3.35887 7 5.00752V6.01003H9V5.00752C9 4.45144 9.44531 4.00501 10 4.00501H14C14.5547 4.00501 15 4.45144 15 5.00752V6.01003H17V5.00752C17 3.35887 15.6445 2 14 2H10ZM4 7.01253C2.89844 7.01253 2 7.91322 2 9.01754V19.0426C2 20.1469 2.89844 21.0476 4 21.0476H20C21.1016 21.0476 22 20.1469 22 19.0426V9.01754C22 7.91322 21.1016 7.01253 20 7.01253H4ZM12 9.01754C14.8008 9.01754 17 11.2223 17 14.0301C17 16.8379 14.8008 19.0426 12 19.0426C9.19922 19.0426 7 16.8379 7 14.0301C7 11.2223 9.19922 9.01754 12 9.01754ZM11 11.0226V13.0276H9V15.0326H11V17.0376H13V15.0326H15V13.0276H13V11.0226H11Z',
  incident:
    'M21.3994 10.6014L13.3986 2.60065C12.6016 1.79978 11.3984 1.79978 10.6014 2.60065L2.60065 10.6014C1.79978 11.3984 1.79978 12.6016 2.60065 13.3986L10.6014 21.3994C11.3984 22.2003 12.6016 22.2003 13.3986 21.3994L21.3994 13.3986C22.2002 12.6016 22.2002 11.3984 21.3994 10.6014ZM13.0001 17.0005H10.9999V15.0003H13.0001V17.0005ZM13.0001 13.0001H10.9999V6.99952H13.0001V13.0001Z',
  medication:
    'M13.5449 9.98234C13.8193 10.571 14.1834 10.7793 14.9674 10.4512L19.386 8.66962C21.2845 7.90387 22.1525 5.85665 21.3293 4.09594C20.506 2.33523 18.3051 1.5226 16.4067 2.28835L11.9881 4.06469C11.2712 4.34598 11.0976 4.77314 11.3776 5.34094C12.1001 6.89328 12.8225 8.43521 13.5449 9.98234ZM12.2569 10.5033C11.5344 8.95613 10.812 7.409 10.0952 5.86707C9.84316 5.28885 9.38394 5.11174 8.67271 5.40866L4.2541 7.185C2.35562 7.95075 1.48758 9.99797 2.31081 11.7587C3.13405 13.5194 5.33495 14.332 7.23344 13.5663L11.652 11.7847C12.4473 11.4826 12.5313 11.0867 12.2569 10.5033ZM20.3156 13.8163C19.918 13.4933 19.2852 13.4986 19.0052 14.2122L17.6443 17.5513L16.2835 20.8956C15.9866 21.6041 16.4571 21.9948 16.9835 22C19.0052 21.9896 20.9093 20.8383 21.6709 18.9734C22.4325 17.1033 21.8277 15.0717 20.3156 13.8163ZM17.6331 13.7278C17.9299 13.0193 17.4595 12.6286 16.9275 12.6234C14.9058 12.6338 13.0017 13.7851 12.2401 15.65C11.4784 17.5148 12.0833 19.5464 13.5953 20.8019C13.9929 21.1248 14.6258 21.1196 14.9058 20.406L16.2667 17.0669L17.6331 13.7278Z',
  social:
    'M20.5889 18.8469H20.4518V22H15.8129V18.8469H15.6758C15.596 18.8469 15.5183 18.8389 15.4427 18.824C15.2818 18.7924 15.1631 18.6556 15.1631 18.4916V18.3229C15.1631 18.1998 15.2296 18.0849 15.3389 18.0287C16.0616 17.6573 16.5574 16.9038 16.5574 16.0369V11.4013C16.5574 11.2216 16.7031 11.0758 16.8829 11.0758H20.4591C21.222 11.0758 21.846 11.7 21.846 12.4627V17.5898C21.846 18.2811 21.2803 18.8469 20.5889 18.8469ZM17.8865 9.21622C16.7829 9.21622 15.8798 8.31333 15.8798 7.20956V6.21311C15.8798 5.10933 16.7827 4.20644 17.8865 4.20644H18.3785C19.482 4.20644 20.3851 5.10933 20.3851 6.21311V7.20956C20.3851 8.31311 19.4823 9.21622 18.3785 9.21622H17.8865ZM8.17048 18.8469H8.03314V22H3.39425V18.8469H3.25714C2.56581 18.8469 2.00003 18.2811 2.00003 17.5898V12.4627C2.00003 11.6998 2.62425 11.0758 3.38692 11.0758H6.84381C7.02359 11.0758 7.16936 11.2216 7.16936 11.4013V16.0369C7.16936 16.904 7.66492 17.6573 8.38781 18.0287C8.49736 18.0849 8.56359 18.2 8.56359 18.3229V18.5089C8.56359 18.6762 8.44159 18.8249 8.27514 18.8416C8.2407 18.8451 8.20581 18.8469 8.17048 18.8469ZM5.95981 9.21622H5.46781C4.36425 9.21622 3.46114 8.31333 3.46114 7.20956V6.21311C3.46114 5.10933 4.36403 4.20644 5.46781 4.20644H5.95981C7.06336 4.20644 7.96648 5.10933 7.96648 6.21311V7.20956C7.96648 8.31311 7.06359 9.21622 5.95981 9.21622ZM14.3198 17.294H14.1827V22H9.54381V17.294H9.4067C8.71536 17.294 8.14959 16.7282 8.14959 16.0369V10.2562C8.14959 9.49333 8.77381 8.86933 9.53648 8.86933H14.19C14.9529 8.86933 15.5769 9.49356 15.5769 10.2562V16.0369C15.5769 16.7282 15.0111 17.294 14.3198 17.294ZM11.6174 7.00978C10.5136 7.00978 9.6107 6.10689 9.6107 5.00311V4.00667C9.6107 2.90289 10.5136 2 11.6174 2H12.1094C13.2129 2 14.116 2.90289 14.116 4.00667V5.00311C14.116 6.10667 13.2131 7.00978 12.1094 7.00978H11.6174Z',
  'three-bars': 'M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z'
}

export const TASK_STATUS_ICONS = {
  completed: 'tick-in-circle',
  pending: 'clock',
  skipped: 'skip',
  overdue: 'incident'
}

export const INTERCOM_PATHS = [
  '/',
  '/organisation/shift-passwords',
  '/organisation/documents',
  '/group-reports',
  '/group-reports/care-plans',
  '/group-reports/bmi',
  '/group-reports/todos',
  '/group-reports/incidents',
  '/logs',
  '/log-revisions',
  '/todos/dashboard',
  '/todos/manage',
  '/reports/coronavirus',
  '/reports/incidents',
  '/reports/careplans',
  '/reports/fluids',
  '/reports/meals',
  '/reports/handovers/current',
  '/reports/handovers/history',
  '/settings/billing',
  '/settings/zones',
  '/help'
]

export const regexp = {
  email:
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.['a-z0-9!#$%&*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
  nationalInsurance:
    /^[A-CEGHJ-PR-TW-Z]{1}[A-CEGHJ-NPR-TW-Z]{1}[0-9]{6}[A-D]{1}$/i
}

export const RISK_LEVELS = {
  na: 'Not at risk',
  low: 'Low risk',
  medium: 'Moderate risk',
  high: 'High risk',
  severe: 'Severe risk'
}

export const RISK_MATRIX_VALUES_INDEXES = [
  [0, 1, 2, 3, 4],
  [1, 3, 5, 7, 9],
  [2, 5, 8, 11, 14],
  [3, 7, 11, 15, 19],
  [4, 9, 14, 19, 24]
]

export const FIELD_TYPES_MAP = {
  'radio-group': 'radios',
  'checkbox-group': 'checkbox'
}

export const REACT_SWITCH_PROPS = {
  handleDiameter: 16,
  uncheckedIcon: false,
  checkedIcon: false,
  boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.6)',
  activeBoxShadow: '0px 0px 1px 10px rgba(0, 0, 0, 0.2)',
  height: 20,
  width: 50
}

export const PROFILE_PICTURE_PLACEHOLDER =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/profile_avatar_blank_X5.png'

export const BMI_VALUES = [
  {
    label: 'Underweight',
    low: 0,
    high: 18.5
  },
  {
    label: 'Healthy',
    low: 18.5,
    high: 25
  },
  {
    label: 'Overweight',
    low: 25,
    high: 30
  },
  {
    label: 'Obese',
    low: 30,
    high: 40
  },
  {
    label: 'Extremely obese',
    low: 40,
    high: 1000
  }
]

const MCEnum = MentalCapacityToConsentSchema.enum

export const MENTAL_CAPACITY_OPTIONS: {
  value: MentalCapacityToConsent
  label: string
}[] = [
  { value: MCEnum.yes, label: 'Yes' },
  { value: MCEnum.no, label: 'No' },
  { value: MCEnum.in_progress, label: 'In progress' },
  { value: MCEnum.unknown, label: 'Unknown' }
]

export const BLOOD_TYPE = [
  { value: 'A+', label: 'A RhD positive (A+)' },
  { value: 'A-', label: 'A RhD negative (A-)' },
  { value: 'B+', label: 'B RhD positive (B+)' },
  { value: 'B-', label: 'B RhD negative (B-)' },
  { value: 'O+', label: 'O RhD positive (O+)' },
  { value: 'O-', label: 'O RhD negative (O-)' },
  { value: 'AB+', label: 'AB RhD positive (AB+)' },
  { value: 'AB-', label: 'AB RhD negative (AB-)' },
  { value: 'Unknown', label: 'Unknown' }
]

export const MARITAL_STATUSES = [
  { value: 'Married' },
  { value: 'Single' },
  { value: 'Civil partnered' },
  { value: 'Widowed' },
  { value: 'Divorced' }
]

/**
 * @deprecated
 * delete this once LMC-2972 reaches prod
 */
export const RELIGIONS = [
  {
    value: 'Christianity',
    label: 'Christianity'
  },
  {
    value: 'Islam',
    label: 'Islam'
  },
  {
    value: 'Secular / Nonreligious / Agnostic / Atheist',
    label: 'Secular / Nonreligious / Agnostic / Atheist'
  },
  {
    value: 'Hinduism',
    label: 'Hinduism'
  },
  {
    value: 'Buddhism',
    label: 'Buddhism'
  },
  {
    value: 'Chinese folk religion / Shenism',
    label: 'Chinese folk religion / Shenism'
  },
  {
    value: 'Ethnic religion',
    label: 'Ethnic religion'
  },
  {
    value: 'African traditional religion',
    label: 'African traditional religion'
  },
  {
    value: 'Sikhism',
    label: 'Sikhism'
  },
  {
    value: 'Spiritism',
    label: 'Spiritism'
  },
  {
    value: 'Judaism',
    label: 'Judaism'
  },
  {
    value: "Bahá'í",
    label: "Bahá'í"
  },
  {
    value: 'African Diaspora Religions',
    label: 'African Diaspora Religions'
  },
  {
    value: 'Confucianism',
    label: 'Confucianism'
  },
  {
    value: 'Druze',
    label: 'Druze'
  },
  {
    value: 'Paganism',
    label: 'Paganism'
  },
  {
    value: 'Roman Catholic',
    label: 'Roman Catholic'
  },
  {
    value: 'Indigenous American Religions',
    label: 'Indigenous American Religions'
  },
  {
    value: 'Gnosticism',
    label: 'Gnosticism'
  },
  {
    value: 'Jainism',
    label: 'Jainism'
  },
  {
    value: 'Rastafarianism',
    label: 'Rastafarianism'
  },
  {
    value: 'Shinto',
    label: 'Shinto'
  },
  {
    value: 'Zoroastrianism',
    label: 'Zoroastrianismz'
  },
  {
    value: 'Mormon',
    label: 'Mormon'
  },
  {
    value: 'Other',
    label: 'Other'
  }
]

export const pregnancyStatusOptions = (
  Object.entries(PregnancyStatusDescriptionEnum) as [
    PregnancyStatusCode,
    string
  ][]
).map(([value, label]) => ({
  value,
  label
}))

export const sexualOrientationOptions = (
  Object.entries(SexualOrientationDescriptionEnum) as [
    SexualOrientationCode,
    string
  ][]
).map(([value, label]) => ({
  value,
  label
}))

export const maritalStatusOptions = (
  Object.entries(MaritalStatusDescriptionEnum) as [MaritalStatusCode, string][]
).map(([value, label]) => ({
  value,
  label
}))

export const religionOptions = (
  Object.entries(ReligionDescriptionEnum) as [ReligionCode, string][]
).map(([value, label]) => ({
  value,
  label
}))

export const ethnicityOptions: BaseOptionType[] = (
  Object.entries(EthnicityDescriptionEnum) as [EthnicityCode, string][]
)
  .reduce<BaseOptionType[]>((groupedOptions, [value, fullLabel]) => {
    const [category, ...labelParts] = fullLabel.split(' - ')
    if (!labelParts.length) {
      groupedOptions.push({
        label: category,
        value
      })
    } else {
      const label = labelParts.join(' - ')
      const existingGroup = groupedOptions.find((g) => g.label === category)
      const option = { value, label }

      if (existingGroup?.options) {
        existingGroup.options.push(option)
      } else {
        groupedOptions.push({
          label: category,
          options: [option]
        })
      }
    }
    return groupedOptions
  }, [])
  .sort((a, b) => Number(Boolean(b.options)) - Number(Boolean(a.options)))

export const SEXUAL_PREFERENCES = [
  {
    value: 'Heterosexual',
    label: 'Heterosexual'
  },
  {
    value: 'Gay',
    label: 'Gay'
  },
  {
    value: 'Lesbian',
    label: 'Lesbian'
  },
  {
    value: 'Bisexual',
    label: 'Bisexual'
  },
  {
    value: 'Queer',
    label: 'Queer'
  },
  {
    value: 'Asexual',
    label: 'Asexual'
  },
  {
    value: 'Other',
    label: 'Other'
  }
]

export const ETHNICITIES: BaseOptionType[] = [
  {
    label: 'White',
    options: [
      {
        value: 'English / Welsh / Scottish / Northern Irish / British',
        label: 'English / Welsh / Scottish / Northern Irish / British'
      },
      {
        value: 'Irish',
        label: 'Irish'
      },
      {
        value: 'Gypsy or Irish Traveller',
        label: 'Gypsy or Irish Traveller'
      },
      {
        value: 'Any other White background',
        label: 'Any other White background'
      },
      {
        value: 'Black British',
        label: 'Black British'
      }
    ]
  },
  {
    label: 'Mixed / Multiple ethnic groups',
    options: [
      {
        value: 'White and Black Caribbean',
        label: 'White and Black Caribbean'
      },
      {
        value: 'White and Black African',
        label: 'White and Black African'
      },
      {
        value: 'White and Asian',
        label: 'White and Asian'
      },
      {
        value: 'Any other Mixed / Multiple ethnic background',
        label: 'Any other Mixed / Multiple ethnic background'
      }
    ]
  },
  {
    label: 'Asian / Asian British',
    options: [
      {
        value: 'Indian',
        label: 'Indian'
      },
      {
        value: 'Pakistani',
        label: 'Pakistani'
      },
      {
        value: 'Bangladeshi',
        label: 'Bangladeshi'
      },
      {
        value: 'Chinese',
        label: 'Chinese'
      },
      {
        value: 'Japanese',
        label: 'Japanese'
      },
      {
        value: 'Any other Asian background',
        label: 'Any other Asian background'
      }
    ]
  },
  {
    label: 'Black / African / Caribbean / Black British',
    options: [
      {
        value: 'African and Caribbean',
        label: 'African and Caribbean'
      },
      {
        value: 'African',
        label: 'African'
      },
      {
        value: 'Caribbean',
        label: 'Caribbean'
      },
      {
        value: 'Any other Black / African / Caribbean background',
        label: 'Any other Black / African / Caribbean background'
      }
    ]
  },
  {
    label: 'Other ethnic group',
    options: [
      {
        value: 'Arab',
        label: 'Arab'
      },
      {
        value: 'Hispanic',
        label: 'Hispanic'
      },
      {
        value: 'Latino',
        label: 'Latino'
      },
      {
        value: 'Roma',
        label: 'Roma'
      },
      {
        value: 'Any other ethnic group',
        label: 'Any other ethnic group'
      }
    ]
  }
]

export const LANGUAGES = [
  {
    value: 'Afrikaans',
    label: 'Afrikaans'
  },
  {
    value: 'Albanian',
    label: 'Albanian'
  },
  {
    value: 'Arabic',
    label: 'Arabic'
  },
  {
    value: 'Armenian',
    label: 'Armenian'
  },
  {
    value: 'ASL - American Sign Language',
    label: 'ASL - American Sign Language'
  },
  {
    value: 'Basque',
    label: 'Basque'
  },
  {
    value: 'Bengali',
    label: 'Bengali'
  },
  {
    value: 'BSL - British Sign Language',
    label: 'BSL - British Sign Language'
  },
  {
    value: 'Bulgarian',
    label: 'Bulgarian'
  },
  {
    value: 'Catalan',
    label: 'Catalan'
  },
  {
    value: 'Cambodian',
    label: 'Cambodian'
  },
  {
    value: 'Chinese (Mandarin)',
    label: 'Chinese (Mandarin)'
  },
  {
    value: 'Croation',
    label: 'Croation'
  },
  {
    value: 'Czech',
    label: 'Czech'
  },
  {
    value: 'Danish',
    label: 'Danish'
  },
  {
    value: 'Dutch',
    label: 'Dutch'
  },
  {
    value: 'English',
    label: 'English'
  },
  {
    value: 'Estonian',
    label: 'Estonian'
  },
  {
    value: 'Fiji',
    label: 'Fiji'
  },
  {
    value: 'Finnish',
    label: 'Finnish'
  },
  {
    value: 'French',
    label: 'French'
  },
  {
    value: 'Georgian',
    label: 'Georgian'
  },
  {
    value: 'German',
    label: 'German'
  },
  {
    value: 'Greek',
    label: 'Greek'
  },
  {
    value: 'Gujarati',
    label: 'Gujarati'
  },
  {
    value: 'Hebrew',
    label: 'Hebrew'
  },
  {
    value: 'Hindi',
    label: 'Hindi'
  },
  {
    value: 'Hungarian',
    label: 'Hungarian'
  },
  {
    value: 'Icelandic',
    label: 'Icelandic'
  },
  {
    value: 'Indonesian',
    label: 'Indonesian'
  },
  {
    value: 'Irish',
    label: 'Irish'
  },
  {
    value: 'Italian',
    label: 'Italian'
  },
  {
    value: 'Japanese',
    label: 'Japanese'
  },
  {
    value: 'Javanese',
    label: 'Javanese'
  },
  {
    value: 'Korean',
    label: 'Korean'
  },
  {
    value: 'Latin',
    label: 'Latin'
  },
  {
    value: 'Latvian',
    label: 'Latvian'
  },
  {
    value: 'Lithuanian',
    label: 'Lithuanian'
  },
  {
    value: 'Macedonian',
    label: 'Macedonian'
  },
  {
    value: 'Malay',
    label: 'Malay'
  },
  {
    value: 'Malayalam',
    label: 'Malayalam'
  },
  {
    value: 'Maltese',
    label: 'Maltese'
  },
  {
    value: 'Maori',
    label: 'Maori'
  },
  {
    value: 'Marathi',
    label: 'Marathi'
  },
  {
    value: 'Mongolian',
    label: 'Mongolian'
  },
  {
    value: 'Nepali',
    label: 'Nepali'
  },
  {
    value: 'Norwegian',
    label: 'Norwegian'
  },
  {
    value: 'Persian',
    label: 'Persian'
  },
  {
    value: 'Polish',
    label: 'Polish'
  },
  {
    value: 'Portuguese',
    label: 'Portuguese'
  },
  {
    value: 'Punjabi',
    label: 'Punjabi'
  },
  {
    value: 'Quechua',
    label: 'Quechua'
  },
  {
    value: 'Romanian',
    label: 'Romanian'
  },
  {
    value: 'Russian',
    label: 'Russian'
  },
  {
    value: 'Samoan',
    label: 'Samoan'
  },
  {
    value: 'Serbian',
    label: 'Serbian'
  },
  {
    value: 'Slovak',
    label: 'Slovak'
  },
  {
    value: 'Slovenian',
    label: 'Slovenian'
  },
  {
    value: 'Somali',
    label: 'Somali'
  },
  {
    value: 'Spanish',
    label: 'Spanish'
  },
  {
    value: 'Swahili',
    label: 'Swahili'
  },
  {
    value: 'Swedish ',
    label: 'Swedish'
  },
  {
    value: 'Tamil',
    label: 'Tamil'
  },
  {
    value: 'Tatar',
    label: 'Tatar'
  },
  {
    value: 'Telugu',
    label: 'Telugu'
  },
  {
    value: 'Thai',
    label: 'Thai'
  },
  {
    value: 'Tibetan',
    label: 'Tibetan'
  },
  {
    value: 'Tonga',
    label: 'Tonga'
  },
  {
    value: 'Turkish',
    label: 'Turkish'
  },
  {
    value: 'Ukranian',
    label: 'Ukranian'
  },
  {
    value: 'Urdu',
    label: 'Urdu'
  },
  {
    value: 'Uzbek',
    label: 'Uzbek'
  },
  {
    value: 'Vietnamese',
    label: 'Vietnamese'
  },
  {
    value: 'Welsh',
    label: 'Welsh'
  },
  {
    value: 'Xhosa',
    label: 'Xhosa'
  },
  {
    value: 'Non verbal',
    label: 'Non verbal'
  }
]

export const NATIONALITIES = [
  {
    value: 'Afghan',
    label: 'Afghan'
  },
  {
    value: 'Albanian',
    label: 'Albanian'
  },
  {
    value: 'Algerian',
    label: 'Algerian'
  },
  {
    value: 'American',
    label: 'American'
  },
  {
    value: 'Andorran',
    label: 'Andorran'
  },
  {
    value: 'Angolan',
    label: 'Angolan'
  },
  {
    value: 'Antiguans',
    label: 'Antiguans'
  },
  {
    value: 'Argentinean',
    label: 'Argentinean'
  },
  {
    value: 'Armenian',
    label: 'Armenian'
  },
  {
    value: 'Australian',
    label: 'Australian'
  },
  {
    value: 'Austrian',
    label: 'Austrian'
  },
  {
    value: 'Azerbaijani',
    label: 'Azerbaijani'
  },
  {
    value: 'Bahamian',
    label: 'Bahamian'
  },
  {
    value: 'Bahraini',
    label: 'Bahraini'
  },
  {
    value: 'Bangladeshi',
    label: 'Bangladeshi'
  },
  {
    value: 'Barbadian',
    label: 'Barbadian'
  },
  {
    value: 'Barbudans',
    label: 'Barbudans'
  },
  {
    value: 'Batswana',
    label: 'Batswana'
  },
  {
    value: 'Belarusian',
    label: 'Belarusian'
  },
  {
    value: 'Belgian',
    label: 'Belgian'
  },
  {
    value: 'Belizean',
    label: 'Belizean'
  },
  {
    value: 'Beninese',
    label: 'Beninese'
  },
  {
    value: 'Bhutanese',
    label: 'Bhutanese'
  },
  {
    value: 'Bolivian',
    label: 'Bolivian'
  },
  {
    value: 'Bosnian',
    label: 'Bosnian'
  },
  {
    value: 'Brazilian',
    label: 'Brazilian'
  },
  {
    value: 'British',
    label: 'British'
  },
  {
    value: 'Bruneian',
    label: 'Bruneian'
  },
  {
    value: 'Bulgarian',
    label: 'Bulgarian'
  },
  {
    value: 'Burkinabe',
    label: 'Burkinabe'
  },
  {
    value: 'Burmese',
    label: 'Burmese'
  },
  {
    value: 'Burundian',
    label: 'Burundian'
  },
  {
    value: 'Cambodian',
    label: 'Cambodian'
  },
  {
    value: 'Cameroonian',
    label: 'Cameroonian'
  },
  {
    value: 'Canadian',
    label: 'Canadian'
  },
  {
    value: 'Cape Verdean',
    label: 'Cape Verdean'
  },
  {
    value: 'Central African',
    label: 'Central African'
  },
  {
    value: 'Chadian',
    label: 'Chadian'
  },
  {
    value: 'Chilean',
    label: 'Chilean'
  },
  {
    value: 'Chinese',
    label: 'Chinese'
  },
  {
    value: 'Colombian',
    label: 'Colombian'
  },
  {
    value: 'Comoran',
    label: 'Comoran'
  },
  {
    value: 'Congolese',
    label: 'Congolese'
  },
  {
    value: 'Costa Rican',
    label: 'Costa Rican'
  },
  {
    value: 'Croatian',
    label: 'Croatian'
  },
  {
    value: 'Cuban',
    label: 'Cuban'
  },
  {
    value: 'Cypriot',
    label: 'Cypriot'
  },
  {
    value: 'Czech',
    label: 'Czech'
  },
  {
    value: 'Danish',
    label: 'Danish'
  },
  {
    value: 'Djibouti',
    label: 'Djibouti'
  },
  {
    value: 'Dominican',
    label: 'Dominican'
  },
  {
    value: 'Dutch',
    label: 'Dutch'
  },
  {
    value: 'East Timorese',
    label: 'East Timorese'
  },
  {
    value: 'Ecuadorean',
    label: 'Ecuadorean'
  },
  {
    value: 'Egyptian',
    label: 'Egyptian'
  },
  {
    value: 'Emirian',
    label: 'Emirian'
  },
  {
    value: 'Equatorial Guinean',
    label: 'Equatorial Guinean'
  },
  {
    value: 'Eritrean',
    label: 'Eritrean'
  },
  {
    value: 'Estonian',
    label: 'Estonian'
  },
  {
    value: 'Ethiopian',
    label: 'Ethiopian'
  },
  {
    value: 'Fijian',
    label: 'Fijian'
  },
  {
    value: 'Filipino',
    label: 'Filipino'
  },
  {
    value: 'Finnish',
    label: 'Finnish'
  },
  {
    value: 'French',
    label: 'French'
  },
  {
    value: 'Gabonese',
    label: 'Gabonese'
  },
  {
    value: 'Gambian',
    label: 'Gambian'
  },
  {
    value: 'Georgian',
    label: 'Georgian'
  },
  {
    value: 'German',
    label: 'German'
  },
  {
    value: 'Ghanaian',
    label: 'Ghanaian'
  },
  {
    value: 'Greek',
    label: 'Greek'
  },
  {
    value: 'Grenadian',
    label: 'Grenadian'
  },
  {
    value: 'Guatemalan',
    label: 'Guatemalan'
  },
  {
    value: 'Guinea-Bissauan',
    label: 'Guinea-Bissauan'
  },
  {
    value: 'Guinean',
    label: 'Guinean'
  },
  {
    value: 'Guyanese',
    label: 'Guyanese'
  },
  {
    value: 'Haitian',
    label: 'Haitian'
  },
  {
    value: 'Herzegovinian',
    label: 'Herzegovinian'
  },
  {
    value: 'Honduran',
    label: 'Honduran'
  },
  {
    value: 'Hungarian',
    label: 'Hungarian'
  },
  {
    value: 'I-Kiribati',
    label: 'I-Kiribati'
  },
  {
    value: 'Icelander',
    label: 'Icelander'
  },
  {
    value: 'Indian',
    label: 'Indian'
  },
  {
    value: 'Indonesian',
    label: 'Indonesian'
  },
  {
    value: 'Iranian',
    label: 'Iranian'
  },
  {
    value: 'Iraqi',
    label: 'Iraqi'
  },
  {
    value: 'Irish',
    label: 'Irish'
  },
  {
    value: 'Israeli',
    label: 'Israeli'
  },
  {
    value: 'Italian',
    label: 'Italian'
  },
  {
    value: 'Ivorian',
    label: 'Ivorian'
  },
  {
    value: 'Jamaican',
    label: 'Jamaican'
  },
  {
    value: 'Japanese',
    label: 'Japanese'
  },
  {
    value: 'Jordanian',
    label: 'Jordanian'
  },
  {
    value: 'Kazakhstani',
    label: 'Kazakhstani'
  },
  {
    value: 'Kenyan',
    label: 'Kenyan'
  },
  {
    value: 'Kittian and Nevisian',
    label: 'Kittian and Nevisian'
  },
  {
    value: 'Kuwaiti',
    label: 'Kuwaiti'
  },
  {
    value: 'Kyrgyz',
    label: 'Kyrgyz'
  },
  {
    value: 'Laotian',
    label: 'Laotian'
  },
  {
    value: 'Latvian',
    label: 'Latvian'
  },
  {
    value: 'Lebanese',
    label: 'Lebanese'
  },
  {
    value: 'Liberian',
    label: 'Liberian'
  },
  {
    value: 'Libyan',
    label: 'Libyan'
  },
  {
    value: 'Liechtensteiner',
    label: 'Liechtensteiner'
  },
  {
    value: 'Lithuanian',
    label: 'Lithuanian'
  },
  {
    value: 'Luxembourger',
    label: 'Luxembourger'
  },
  {
    value: 'Macedonian',
    label: 'Macedonian'
  },
  {
    value: 'Malagasy',
    label: 'Malagasy'
  },
  {
    value: 'Malawian',
    label: 'Malawian'
  },
  {
    value: 'Malaysian',
    label: 'Malaysian'
  },
  {
    value: 'Maldivan',
    label: 'Maldivan'
  },
  {
    value: 'Malian',
    label: 'Malian'
  },
  {
    value: 'Maltese',
    label: 'Maltese'
  },
  {
    value: 'Marshallese',
    label: 'Marshallese'
  },
  {
    value: 'Mauritanian',
    label: 'Mauritanian'
  },
  {
    value: 'Mauritian',
    label: 'Mauritian'
  },
  {
    value: 'Mexican',
    label: 'Mexican'
  },
  {
    value: 'Micronesian',
    label: 'Micronesian'
  },
  {
    value: 'Moldovan',
    label: 'Moldovan'
  },
  {
    value: 'Monacan',
    label: 'Monacan'
  },
  {
    value: 'Mongolian',
    label: 'Mongolian'
  },
  {
    value: 'Moroccan',
    label: 'Moroccan'
  },
  {
    value: 'Mosotho',
    label: 'Mosotho'
  },
  {
    value: 'Motswana',
    label: 'Motswana'
  },
  {
    value: 'Mozambican',
    label: 'Mozambican'
  },
  {
    value: 'Namibian',
    label: 'Namibian'
  },
  {
    value: 'Nauruan',
    label: 'Nauruan'
  },
  {
    value: 'Nepalese',
    label: 'Nepalese'
  },
  {
    value: 'New Zealander',
    label: 'New Zealander'
  },
  {
    value: 'Nicaraguan',
    label: 'Nicaraguan'
  },
  {
    value: 'Nigerian',
    label: 'Nigerian'
  },
  {
    value: 'Nigerien',
    label: 'Nigerien'
  },
  {
    value: 'North Korean',
    label: 'North Korean'
  },
  {
    value: 'Northern Irish',
    label: 'Northern Irish'
  },
  {
    value: 'Norwegian',
    label: 'Norwegian'
  },
  {
    value: 'Omani',
    label: 'Omani'
  },
  {
    value: 'Pakistani',
    label: 'Pakistani'
  },
  {
    value: 'Palauan',
    label: 'Palauan'
  },
  {
    value: 'Panamanian',
    label: 'Panamanian'
  },
  {
    value: 'Papua New Guinean',
    label: 'Papua New Guinean'
  },
  {
    value: 'Paraguayan',
    label: 'Paraguayan'
  },
  {
    value: 'Peruvian',
    label: 'Peruvian'
  },
  {
    value: 'Polish',
    label: 'Polish'
  },
  {
    value: 'Portuguese',
    label: 'Portuguese'
  },
  {
    value: 'Qatari',
    label: 'Qatari'
  },
  {
    value: 'Romanian',
    label: 'Romanian'
  },
  {
    value: 'Russian',
    label: 'Russian'
  },
  {
    value: 'Rwandan',
    label: 'Rwandan'
  },
  {
    value: 'Saint Lucian',
    label: 'Saint Lucian'
  },
  {
    value: 'Salvadoran',
    label: 'Salvadoran'
  },
  {
    value: 'Samoan',
    label: 'Samoan'
  },
  {
    value: 'San Marinese',
    label: 'San Marinese'
  },
  {
    value: 'Sao Tomean',
    label: 'Sao Tomean'
  },
  {
    value: 'Saudi',
    label: 'Saudi'
  },
  {
    value: 'Scottish',
    label: 'Scottish'
  },
  {
    value: 'Senegalese',
    label: 'Senegalese'
  },
  {
    value: 'Serbian',
    label: 'Serbian'
  },
  {
    value: 'Seychellois',
    label: 'Seychellois'
  },
  {
    value: 'Sierra Leonean',
    label: 'Sierra Leonean'
  },
  {
    value: 'Singaporean',
    label: 'Singaporean'
  },
  {
    value: 'Slovakian',
    label: 'Slovakian'
  },
  {
    value: 'Slovenian',
    label: 'Slovenian'
  },
  {
    value: 'Solomon Islander',
    label: 'Solomon Islander'
  },
  {
    value: 'Somali',
    label: 'Somali'
  },
  {
    value: 'South African',
    label: 'South African'
  },
  {
    value: 'South Korean',
    label: 'South Korean'
  },
  {
    value: 'Spanish',
    label: 'Spanish'
  },
  {
    value: 'Sri Lankan',
    label: 'Sri Lankan'
  },
  {
    value: 'Sudanese',
    label: 'Sudanese'
  },
  {
    value: 'Surinamer',
    label: 'Surinamer'
  },
  {
    value: 'Swazi',
    label: 'Swazi'
  },
  {
    value: 'Swedish',
    label: 'Swedish'
  },
  {
    value: 'Swiss',
    label: 'Swiss'
  },
  {
    value: 'Syrian',
    label: 'Syrian'
  },
  {
    value: 'Taiwanese',
    label: 'Taiwanese'
  },
  {
    value: 'Tajik',
    label: 'Tajik'
  },
  {
    value: 'Tanzanian',
    label: 'Tanzanian'
  },
  {
    value: 'Thai',
    label: 'Thai'
  },
  {
    value: 'Togolese',
    label: 'Togolese'
  },
  {
    value: 'Tongan',
    label: 'Tongan'
  },
  {
    value: 'Trinidadian/Tobagonian',
    label: 'Trinidadian/Tobagonian'
  },
  {
    value: 'Tunisian',
    label: 'Tunisian'
  },
  {
    value: 'Turkish',
    label: 'Turkish'
  },
  {
    value: 'Tuvaluan',
    label: 'Tuvaluan'
  },
  {
    value: 'Ugandan',
    label: 'Ugandan'
  },
  {
    value: 'Ukrainian',
    label: 'Ukrainian'
  },
  {
    value: 'Uruguayan',
    label: 'Uruguayan'
  },
  {
    value: 'Uzbekistani',
    label: 'Uzbekistani'
  },
  {
    value: 'Venezuelan',
    label: 'Venezuelan'
  },
  {
    value: 'Vietnamese',
    label: 'Vietnamese'
  },
  {
    value: 'Welsh',
    label: 'Welsh'
  },
  {
    value: 'Yemenite',
    label: 'Yemenite'
  },
  {
    value: 'Zambian',
    label: 'Zambian'
  },
  {
    value: 'Zimbabwean',
    label: 'Zimbabwean'
  }
]

// HOME SETTINGS //
export const GPS_LOCATION = [
  {
    value: true,
    label: 'Enable GPS Location'
  },
  {
    value: false,
    label: 'Disable GPS Location'
  }
]

// HOME SETTINGS //
export const DEVICE_ACCESS_OPTIONS = [
  {
    value: true,
    label: 'Yes'
  },
  {
    value: false,
    label: 'No'
  }
]

export const ALLOW_VIDEO_UPLOAD_OPTIONS = [
  {
    value: true,
    label: 'Yes'
  },
  {
    value: false,
    label: 'No'
  }
]

export const ALLOW_PHOTO_UPLOAD_OPTIONS = [
  {
    value: true,
    label: 'Yes'
  },
  {
    value: false,
    label: 'No'
  }
]

export const PREFERRED_TERM_RES_OPTIONS: {
  value: PeopleNominatives
  label: string
}[] = [
  { value: PeopleNominatives.residents, label: 'Residents' },
  { value: PeopleNominatives.serviceUsers, label: 'Service Users (SU)' },
  { value: PeopleNominatives.clients, label: 'Clients' },
  { value: PeopleNominatives.tenants, label: 'Tenants' },
  {
    value: PeopleNominatives.supportedPersons,
    label: 'Supported Persons (SP)'
  },
  { value: PeopleNominatives.customers, label: 'Customers' },
  { value: PeopleNominatives.people, label: 'People We Support (People)' },
  {
    value: PeopleNominatives.individuals,
    label: 'Individuals We Support (Individuals)'
  },
  { value: PeopleNominatives.patients, label: 'Patients' }
]

export const PREFERRED_TERM_CARE_OPTIONS = [
  { value: 'Care Plans', label: 'Care Plans' },
  { value: 'Support Plans', label: 'Support Plans' }
]

export const PREFERRED_SERVICE_OPTIONS = [
  { value: LpsDolsSetting.lps, label: 'LPS' },
  { value: LpsDolsSetting.dols, label: 'DoLS' }
]

export const EVERYONE_BUTTON = [
  { value: true, label: 'Show' },
  { value: false, label: 'Hide' }
]

export const SORT_BY_ROOM_NR_OPTIONS = [
  { value: false, label: 'Alphabetically (A - Z)' },
  { value: true, label: 'Room Number (1, 2, 3...)' }
]

export const LIKELIHOOD_OPTIONS = [
  {
    label: 'Rare',
    risk: 'low',
    value: 1
  },
  {
    label: 'Unlikely',
    risk: 'low',
    value: 2
  },
  {
    label: 'Possible',
    risk: 'medium',
    value: 3
  },
  {
    label: 'Likely',
    risk: 'high',
    value: 4
  },
  {
    label: 'Certain',
    risk: 'high',
    value: 5
  }
]

export const SEVERITY_OPTIONS = [
  {
    label: 'Trivial',
    risk: 'low',
    value: 1
  },
  {
    label: 'Minor',
    risk: 'low',
    value: 2
  },
  {
    label: 'Moderate',
    risk: 'medium',
    value: 3
  },
  {
    label: 'Major',
    risk: 'high',
    value: 4
  },
  {
    label: 'Fatality',
    risk: 'high',
    value: 5
  }
]

export const EMAR_REASON_CODES = [
  {
    value: 'A',
    label: 'Absent'
  },
  {
    value: 'AT',
    label: 'Already Taken'
  },
  {
    value: 'LO',
    label: 'Left Out (if risk assessed)'
  },
  {
    value: 'N/V',
    label: 'Nausea or Vomiting'
  },
  {
    value: 'R',
    label: 'Refused'
  },
  {
    value: 'RD',
    label: 'Refused & Destroyed'
  },
  {
    value: 'VP',
    label: 'Verbal Prompt'
  },
  {
    value: 'O',
    label: 'Other'
  }
]

export const EMAR_FREQ_PRESETS = [
  {
    key: 'everyDay',
    freqInterval: '1',
    freqUnit: 'day'
  },
  {
    key: 'everyOtherDay',
    freqInterval: '2',
    freqUnit: 'day'
  },
  {
    key: 'everyThreeDays',
    freqInterval: '3',
    freqUnit: 'day'
  },
  {
    key: 'everyWeek',
    freqInterval: '1',
    freqUnit: 'week'
  },
  {
    key: 'everyFourWeeks',
    freqInterval: '4',
    freqUnit: 'week'
  },
  {
    key: 'everyTwelveWeeks',
    freqInterval: '12',
    freqUnit: 'week'
  }
]

export const defaultDateRanges = {
  'Last Week': [dayjs().subtract(1, 'week'), dayjs()],
  'Last Month': [dayjs().subtract(1, 'month'), dayjs()],
  'Last 3 Months': [dayjs().subtract(3, 'month'), dayjs()],
  'Last Year': [dayjs().subtract(1, 'year'), dayjs()]
}

export const REPORTING_IDS = [
  {
    label: 'Blood Glucose Before (mmol/L)',
    value: 'blood_glucose_before',
    chart: 'blood_glucose'
  },
  {
    label: 'Blood Glucose After (mmol/L)',
    value: 'blood_glucose_after',
    chart: 'blood_glucose'
  },
  {
    label: 'Blood Pressure Upper (mmHg)',
    value: 'blood_pressure_upper',
    chart: 'blood_pressure'
  },
  {
    label: 'Blood Pressure Lower (mmHg)',
    value: 'blood_pressure_lower',
    chart: 'blood_pressure'
  },
  { label: 'Blood Oxygen (% SpO2)', value: 'blood_oxygen' },
  { label: 'Fluids Consumed (ml)', value: 'fluids_in', chart: 'fluids' },
  { label: 'Fluids Out (ml)', value: 'fluids_out', chart: 'fluids' },
  { label: 'Meal (portions consumed)', value: 'meal', max: 1 },
  { label: 'Height (cm)', value: 'height' },
  { label: 'Stock Count', value: 'stock_count_actual' },
  { label: 'Expected Stock Count', value: 'stock_count_expected' },
  { label: 'Heart Rate (bpm)', value: 'heart_rate' },
  { label: 'Seizure', value: 'seizure' },
  {
    label: 'Mobility',
    value: 'mobility',
    options: [
      { label: 'Very Bad', value: 1 },
      { label: 'Bad', value: 2 },
      { label: 'Average', value: 3 },
      { label: 'Good', value: 4 },
      { label: 'Very Good', value: 5 }
    ]
  },
  {
    label: 'Mood Score',
    options: [
      { label: 'Lowest', value: 1 },
      { label: 'Low', value: 2 },
      { label: 'Neutral', value: 3 },
      { label: 'Good', value: 4 },
      { label: 'Best', value: 5 }
    ],
    value: 'mood'
  },
  { label: 'MUST', value: 'must' },
  { label: 'Respiratory Rate (breaths / min)', value: 'respiratory_rate' },
  {
    label: 'Bristol Type',
    options: [
      { label: 'Type 1: Separate hard lumps', value: 1 },
      { label: 'Type 2: Lumpy and sausage-like', value: 2 },
      {
        label: 'Type 3: Sausage shape but with cracks on the surface',
        value: 3
      },
      { label: 'Type 4: Like a smooth, soft sausage or snake', value: 4 },
      { label: 'Type 5: Soft blobs with clear cut edges', value: 5 },
      { label: 'Type 6: Mushy consistency with ragged edges', value: 6 },
      { label: 'Type 7: Liquid consistency with no solid pieces', value: 7 }
    ],
    value: 'stool'
  },
  { label: 'Temperature (°C)', value: 'temperature' },
  { label: 'Waterlow Score', value: 'waterlow' },
  { label: 'Weight (kg)', value: 'weight' },
  {
    label: 'Pain Level (at rest)',
    value: 'painchekAtRest',
    chart: 'painchek',
    options: [
      { label: 'NA', value: 0 },
      { label: 'Mild', value: 1 },
      { label: 'Moderate', value: 2 },
      { label: 'Severe', value: 3 }
    ]
  },
  {
    label: 'Pain Level (post movement)',
    value: 'painchekPostMovement',
    chart: 'painchek',
    options: [
      { label: 'NA', value: 0 },
      { label: 'Mild', value: 1 },
      { label: 'Moderate', value: 2 },
      { label: 'Severe', value: 3 }
    ]
  }
]

export const NHS_TRACE_STATUS_MAP: Record<
  string,
  {
    label: string
    shortLabel: string
    tooltip: string
    iconType: 'check' | 'info' | 'error'
    iconColor: string
    popoverLink?: { label: string; url: string }
  }
> = {
  '01': {
    label: 'Number present and verified',
    shortLabel: 'Number present & traced.',
    tooltip: 'Number confirmed in NHS records.',
    iconType: 'check',
    iconColor: '#52c41a'
  },
  '02': {
    label: 'Number present but not traced',
    shortLabel: 'Number present but not traced.',
    tooltip: "Number hasn't yet been checked against NHS records.",
    iconType: 'info',
    iconColor: '#1890ff',
    popoverLink: {
      label: 'See how to check NHS number using GP Connect',
      url: 'https://support.logmycare.co.uk/en/articles/10470275-gp-connect-integration-setup'
    }
  },
  '04': {
    label: 'Trace attempted - No match or multiple match found',
    shortLabel: 'Trace attempted.',
    tooltip:
      'No match or multiple matches found in NHS records. Possible reasons: data issues or patients who are harder to trace.',
    iconType: 'error',
    iconColor: '#de7c12'
  }
}

export const CARER_GENDER_GENDER = [Gender.any, Gender.female, Gender.male].map(
  (gender) => ({
    value: gender,
    label: gender
  })
)

/** Dropdown shows Mods descriptors (`label`); collapsed value uses `displayLabel` (see Demographic labelRender, AntdSelectField). */
export const GENDER_IDENTITY_OPTIONS = Object.values(GenderIdentityEnum).map(
  (code) => ({
    value: code,
    label: GenderIdentityDescriptionEnum[code],
    displayLabel: GenderIdentityDisplayLabelEnum[code]
  })
)

export const SEX_OPTIONS = Object.values(SexEnum).map((code) => ({
  value: code,
  label: SexDescriptionEnum[code]
}))
